<template>
  <div class="dashboard">
    <SideNav v-bind:page_active="page_active" />

    <div class="main-section">
      <TopNav />

      <div class="content-body">
        <div class="row breadcrumb-area">
          <div class="col-lg-6">
            <h6><b>Settings</b></h6>
          </div>
          <div class="col-lg-6">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/dashboard">Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">Settings</li>
              </ol>
            </nav>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-9">
            <!-- Settings content goes here -->
          </div>

          <div class="col-lg-3">
            <div class="card shadow-sm">
              <div class="card-header mb-1">
                <b>Links</b>
              </div>

              <a href="/profile" class="settings-link">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0.699951C4.48 0.699951 0 5.17995 0 10.7C0 16.22 4.48 20.7 10 20.7C15.52 20.7 20 16.22 20 10.7C20 5.17995 15.52 0.699951 10 0.699951ZM10 3.69995C11.66 3.69995 13 5.03995 13 6.69995C13 8.35995 11.66 9.69995 10 9.69995C8.34 9.69995 7 8.35995 7 6.69995C7 5.03995 8.34 3.69995 10 3.69995ZM10 17.9C7.5 17.9 5.29 16.62 4 14.68C4.03 12.69 8 11.6 10 11.6C11.99 11.6 15.97 12.69 16 14.68C14.71 16.62 12.5 17.9 10 17.9Z"
                    fill="currentColor"
                  />
                </svg>
                Profile
              </a>

              <a href="/sessions" class="settings-link">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 512 512"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M40 48C26.7 48 16 58.7 16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM16 232l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"
                  />
                </svg>
                Sessions
              </a>
            </div>
          </div>
        </div>

        <Copyright />
      </div>
    </div>
  </div>
</template>

<script>
import SideNav from "@/components/SideNav.vue";
import Copyright from "@/components/Copyright.vue";
import TopNav from "@/components/TopNav.vue";

export default {
  name: "Settings",
  components: { SideNav, TopNav, Copyright },

  data() {
    return {
      page_active: "settings",
    };
  },
};
</script>

<style scoped>
.settings-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 10px 10px 20px;
  border-bottom: 1px solid #f2f2f2;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  transition: background 0.15s, color 0.15s;
}

.settings-link:hover {
  background: #006e40;
  color: #fff;
  text-decoration: none;
}

.settings-link:last-child {
  border-bottom: none;
}
</style>
